import type { ScheduleSolversTimeConfigType } from '../../types';

export const noRepeatTime = ({
  endDate,
  userDate
}: ScheduleSolversTimeConfigType) => {
  return endDate.getTime() - userDate.getTime();
};
